import {Grid} from '@yandex-delivery/blocks'
import {HeaderButton} from '@yandex-delivery/order-layout-blocks'
import React from 'react'

export type NavLink = {
  label: string
  links: {href: string; label: string; rel?: string; target?: string}[]
}

export default function NavLinks({navLinks}: {navLinks: NavLink[]}) {
  return (
    <Grid alignItems="flex-start" container>
      {navLinks.map(({label, links}) => (
        <Grid container direction="column" item key={label} xs>
          <Grid item xs>
            <HeaderButton active size="s" transparent variant="pseudo">
              {label}
            </HeaderButton>
            {links.map(({label: linkLabel, ...linkProps}) => (
              <Grid item key={linkLabel} xs>
                <HeaderButton
                  {...linkProps}
                  size="s"
                  transparent
                  variant="pseudo"
                >
                  {linkLabel}
                </HeaderButton>
              </Grid>
            ))}
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}
